import { FC, useEffect, useState } from 'react';
import { Button, Text } from '@livechat/design-system-react-components';

import { LocalStorageKey } from 'constants/local-storage';
import { getItem, removeItem, saveItem } from 'helpers/storage/local-storage';

import * as styles from './styles';

type Props = {
  onClick(): void;
};

export const CountdownTimer: FC<Props> = ({ onClick }) => {
  const [time, setTime] = useState(
    parseInt((getItem(LocalStorageKey.VerificationEmailLimitCountdown) ?? 600).toString(), 10)
  );

  useEffect(() => {
    const timer = setInterval(() => {
      if (time > 0) {
        setTime((prevTime) => prevTime - 1);
      } else {
        removeItem(LocalStorageKey.VerificationEmailLimitCountdown);
        clearInterval(timer);
      }
    }, 1000);

    return () => {
      clearInterval(timer);
      saveItem(LocalStorageKey.VerificationEmailLimitCountdown, time);
    };
  }, [time]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
  };

  return (
    <Button css={styles.button} role="button" kind="text" onClick={onClick} disabled={time > 0}>
      {time > 0 && <Text>Send it again in {formatTime(time)}</Text>}
      {time <= 0 && <Text>Send it again</Text>}
    </Button>
  );
};
